import React, {Component} from 'react';

class Checklist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data
    }
  }

  onChange = (event) => {
    let data = this.state.data;
    let index = event.target.value;
    data[index].checked = !data[index].checked;
    this.setState({data: data});
    this.props.setFieldValue('roles', data.filter((item) => item.checked).map((item) => item.name));
    //this.props.setFieldValue('permissions', selectedNodes.map((node) => node.value));
  }

  render = () => {
    return (
      <div className="form-group">
        <label className="col-md-4 control-label">{this.props.label}</label>
        <div className="col-md-8">
          {
            this.state.data.map((item, index) => {
              return (
                <div className="form-check form-check-inline" key={`checkList${item.name}`}>
                  <input 
                    className="form-check-input"
                    type="checkbox"
                    id={`checkList${item.name}`}
                    value={index}
                    checked={item.checked}
                    onChange={this.onChange}
                  />
                  <label className="form-check-label" htmlFor={`checkList${item.name}`}>{item.name}</label>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
}

export default Checklist;



// WEBPACK FOOTER //
// ./src/Components/Form/Checklist.js